import React, { FunctionComponent } from 'react';
import { Typography, TTypographyProps } from '@rbx/ui';
import DynamicallyRouted from '@modules/miscellaneous/common/components/DynamicallyRouted';

export interface OpenCloudObjectReferenceProps {
  objectName: string;
  variant?: TTypographyProps['variant'];
  showObjectForReference?: boolean;
}

const OpenCloudObjectReference: FunctionComponent<
  React.PropsWithChildren<OpenCloudObjectReferenceProps>
> = ({ objectName, showObjectForReference, variant = 'code' }) => {
  if (objectName === null || objectName === undefined || objectName === '') {
    return null;
  }

  if (showObjectForReference) {
    return (
      <Typography variant={variant} color='secondary'>
        object
      </Typography>
    );
  }

  return (
    <DynamicallyRouted.Link
      href={`#${objectName.replace(/\s+/g, '_')}`}
      underline='none'
      color='primary'>
      <Typography variant={variant} color='inherit'>
        {objectName}
      </Typography>
    </DynamicallyRouted.Link>
  );
};

export default OpenCloudObjectReference;
